import { KText } from '@/ui-library/components';
import { Flex } from '@chakra-ui/react';

export const AlreadyPartOf = ({
  items = [],
  valueKey = 'name',
  type = 'flow',
}) => {
  if (items?.length === 0) return null;

  return (
    <Flex mt="12px" flexDir="column" px="24px" gap="12px">
      <KText size="sm-semi-bold">
        This candidate is already part of the following {type}
        {items?.length > 1 ? 's' : ''}
      </KText>
      <Flex
        border="1px solid"
        borderColor="border-color"
        maxH="150px"
        overflowY="auto"
        flexDir="column"
        borderRadius="xs"
        px="8px"
      >
        {items?.map((item) => {
          const value = item?.[valueKey];
          return (
            <KText key={item?.id} size="sm-medium" p="8px">
              {value}
            </KText>
          );
        })}
      </Flex>
    </Flex>
  );
};
